import jsonStyles from './StylesCarnet.json';

export const PDF_A4 = [595.2765, 841.8905];
export const PDF_CARTA = [612, 792];

// export const ANCHO_CARNET = 5.8 * 28.3465;
export const ANCHO_CARNET = 5.55 * 28.3465;
export const ALTO_CARNET = 8.68 * 28.5465;

export const TITLE_TEXT_CONST = 'titleText';
export const TITLE_STYLES_CONST = 'titleStyles';
export const SUBTITLE_TEXT_CONST = 'subtitleText';
export const SUBTITLE_STYLES_CONST = 'subtitleStyles';
export const PROFILE_STYLES_CONST = 'profileStyles';
export const TITLE_FULLNAME_STYLES_CONST = 'titleFullnameStyles';
export const NAMES_STYLES_CONST = 'namesStyles';
export const SURNAMES_STYLES_CONST = 'surnamesStyles';
export const PHOTO_STYLES_CONST = 'photoStyles';
export const TITLE_DNI_STYLES_CONST = 'titleDniStyles';
export const DNI_STYLES_CONST = 'dniStyles';
export const TITLE_NIVEL_STYLES_CONST = 'titleNivelStyles';
export const NIVEL_STYLES_CONST = 'nivelStyles';
export const TITLE_AGE_TEXT_CONST = 'titleAgeText';
export const TITLE_AGE_STYLES_CONST = 'titleAgeStyles';
export const AGE_STYLES_CONST = 'ageStyles';
export const TITLE_PERIODO_STYLES_CONST = 'titlePeriodoStyles';
export const PERIODO_STYLES_CONST = 'periodoStyles';
export const TITLE_SECCION_STYLES_CONST = 'titleSeccionStyles';
export const SECCION_STYLES_CONST = 'seccionStyles';
export const TITLE_CARRERA_STYLES_CONST = 'titleCarreraStyles';
export const CARRERA_STYLES_CONST = 'carreraStyles';
export const LOGO_LEFT_CONST = 'logoLeft';
export const LOGO_LEFT_STYLES_CONST = 'logoLeftStyles';
export const LOGO_RIGHT_CONST = 'logoRight';
export const LOGO_RIGHT_STYLES_CONST = 'logoRightStyles';
export const FONDO_CONST = 'fondo';
export const FONDO_STYLES_CONST = 'fondoStyles';
export const TITLE_BACK_TEXT_CONST = 'titleBackText';
export const TITLE_BACK_STYLES_CONST = 'titleBackStyles';
export const SUBTITLE_BACK_TEXT_CONST = 'subtitleBackText';
export const SUBTITLE_BACK_STYLES_CONST = 'subtitleBackStyles';
export const QRCODE_STYLES_CONST = 'qrcodeStyles';
export const TITLE_FIRMA_STYLES_CONST = 'titleFirmaStyles';
export const FIRMA_STYLES_CONST = 'firmaStyles';
export const FIRMA_CONST = 'firma';
export const LOGO_LEFT_BACK_CONST = 'logoLeftBack';
export const LOGO_LEFT_BACK_STYLES_CONST = 'logoLeftBackStyles';
export const LOGO_RIGHT_BACK_CONST = 'logoRightBack';
export const LOGO_RIGHT_BACK_STYLES_CONST = 'logoRightBackStyles';
export const FONDO_BACK_CONST = 'fondoBack';
export const FONDO_BACK_STYLES_CONST = 'fondoBackStyles';
export const TITLE_SECCION_TEXT_CONST = 'titleSeccionText';
export const TITLE_NIVEL_TEXT_CONST = 'titleNivelText';
export const TITLE_FIRMA_TEXT_CONST = 'titleFirmaText';
export const PARAMETRO1 = 'parametro1';
export const PARAMETRO1_STYLES = 'parametro1Styles';
export const PARAMETRO2 = 'parametro2';
export const PARAMETRO2_STYLES = 'parametro2Styles';

export const componentsCarnet = [
  { id: TITLE_TEXT_CONST, name: 'Título texto', notShow: true },
  { id: TITLE_STYLES_CONST, name: 'Título' },
  { id: SUBTITLE_TEXT_CONST, name: 'Subtîtulo texto', notShow: true },
  { id: SUBTITLE_STYLES_CONST, name: 'Subtítulo' },
  { id: PROFILE_STYLES_CONST, name: 'Perfil' },
  { id: TITLE_FULLNAME_STYLES_CONST, name: 'Título nom. y ape.' },
  { id: NAMES_STYLES_CONST, name: 'Nombres' },
  { id: SURNAMES_STYLES_CONST, name: 'Apellidos' },
  { id: PHOTO_STYLES_CONST, name: 'Foto' },
  { id: TITLE_DNI_STYLES_CONST, name: 'Título DNI' },
  { id: DNI_STYLES_CONST, name: 'DNI' },
  {
    id: TITLE_NIVEL_TEXT_CONST,
    name: 'Texto en titulo de nivel',
    notShow: true,
  },
  { id: TITLE_NIVEL_STYLES_CONST, name: 'Título Nivel' },
  { id: NIVEL_STYLES_CONST, name: 'Nivel' },
  { id: TITLE_AGE_TEXT_CONST, name: 'Texto en titulo de edad', notShow: true },
  { id: TITLE_AGE_STYLES_CONST, name: 'Título de edad' },
  { id: AGE_STYLES_CONST, name: 'Edad' },
  { id: TITLE_PERIODO_STYLES_CONST, name: 'Título Periodo' },
  { id: PERIODO_STYLES_CONST, name: 'Periodo' },
  {
    id: TITLE_SECCION_TEXT_CONST,
    name: 'Texto en titulo de seccion',
    notShow: true,
  },
  { id: TITLE_SECCION_STYLES_CONST, name: 'Título Seccion' },
  { id: SECCION_STYLES_CONST, name: 'Seccion' },
  { id: TITLE_CARRERA_STYLES_CONST, name: 'Título Carrera' },
  { id: CARRERA_STYLES_CONST, name: 'Carrera' },
  { id: LOGO_LEFT_CONST, name: 'Logo izquierdo', notShow: true },
  { id: LOGO_LEFT_STYLES_CONST, name: 'Logo izquierdo' },
  { id: LOGO_RIGHT_CONST, name: 'Logo derecho', notShow: true },
  { id: LOGO_RIGHT_STYLES_CONST, name: 'Logo derecho' },
  { id: FONDO_CONST, name: 'Fondo frontal', notShow: true },
  { id: FONDO_STYLES_CONST, name: 'Fondo frontal' },
  { id: TITLE_BACK_TEXT_CONST, name: 'Titulo reversa texto', notShow: true },
  { id: TITLE_BACK_STYLES_CONST, name: 'Título Reversa' },
  {
    id: SUBTITLE_BACK_TEXT_CONST,
    name: 'Subtitulo reversa texto',
    notShow: true,
  },
  { id: SUBTITLE_BACK_STYLES_CONST, name: 'Subtítulo reversa' },
  { id: QRCODE_STYLES_CONST, name: 'Codigo QR' },
  { id: LOGO_LEFT_BACK_CONST, name: 'Logo izquierdo reversa', notShow: true },
  { id: LOGO_LEFT_BACK_STYLES_CONST, name: 'Logo izquierdo reversa' },
  { id: LOGO_RIGHT_BACK_CONST, name: 'Logo derecho reversa', notShow: true },
  { id: LOGO_RIGHT_BACK_STYLES_CONST, name: 'Logo derecho reversa' },
  { id: FONDO_BACK_CONST, name: 'Fondo Reverso', notShow: true },
  { id: FONDO_BACK_STYLES_CONST, name: 'Fondo Reverso' },
  { id: TITLE_FIRMA_STYLES_CONST, name: 'Título Firma' },
  { id: FIRMA_STYLES_CONST, name: 'Firma' },
  { id: FIRMA_CONST, name: 'Firma', notShow: true },
  { id: TITLE_FIRMA_TEXT_CONST, name: 'Texto titulo firma', notShow: true },
  { id: PARAMETRO1_STYLES, name: 'Parametro 1' },
  { id: PARAMETRO1, name: 'Parametro 1', notShow: true },
  { id: PARAMETRO2_STYLES, name: 'Parametro 2' },
  { id: PARAMETRO2, name: 'Parametro 2', notShow: true },
];

export const WIDTH_CONST = 'width';
export const HEIGHT_CONST = 'height';
export const X_CONST = 'x';
export const Y_CONST = 'y';
export const FONT_SIZE_CONST = 'fontSize';
export const FONT_COLOR_CONST = 'fontColor';
export const FONT_FAMILY_CONST = 'fontFamily';
export const FONT_WEIGHT_CONST = 'fontWeight';
export const FONT_STYLE_CONST = 'fontStyle';
export const TEXT_ALIGN_CONST = 'textAlign';
export const LINE_HEIGHT_CONST = 'lineHeight';
export const TEXT_BASELINE_CONST = 'textBaseline';
export const BACKGROUND_COLOR_CONST = 'backgroundColor';
export const BORDER_COLOR_CONST = 'borderColor';
export const BORDER_RADIUS_CONST = 'borderRadius';
export const BORDER_WIDTH_CONST = 'borderWidth';
export const DISPLAY_CONST = 'display';
export const TEXT_SHADOW_X_CONST = 'textShadowX';
export const TEXT_SHADOW_Y_CONST = 'textShadowY';
export const TEXT_SHADOW_BLUR_CONST = 'textShadowBlur';
export const TEXT_SHADOW_COLOR_CONST = 'textShadowColor';

export const getNameComponent = (id) => {
  const component = componentsCarnet.find((el) => el.id === id);

  return component ? component.name : jsonStyles[id];
};

export const stylesComponentArray = [
  { id: WIDTH_CONST, name: 'Ancho' }, // 0
  { id: HEIGHT_CONST, name: 'Alto' }, // 1
  { id: X_CONST, name: 'Pos. Horizontal' }, // 2
  { id: Y_CONST, name: 'Pos. Vertical.' }, // 3
  { id: FONT_SIZE_CONST, name: 'Tamaño texto' }, // 4
  { id: FONT_COLOR_CONST, name: 'Color texto' }, // 5
  { id: FONT_FAMILY_CONST, name: 'Fuente' }, // 6
  { id: FONT_WEIGHT_CONST, name: 'Negrita' }, // 7
  { id: TEXT_ALIGN_CONST, name: 'Texto Horizontal' }, // 8
  { id: LINE_HEIGHT_CONST, name: 'Altura de línea' }, // 9
  { id: TEXT_BASELINE_CONST, name: 'Aliniacion texto' }, // 10
  { id: BACKGROUND_COLOR_CONST, name: 'Color de fondo' }, // 11
  { id: BORDER_COLOR_CONST, name: 'Color de borde' }, // 12
  { id: BORDER_RADIUS_CONST, name: 'Radio de borde' }, // 13
  { id: BORDER_WIDTH_CONST, name: 'Ancho de borde' }, // 14
  { id: DISPLAY_CONST, name: 'Visible' }, // 15
  { id: TEXT_SHADOW_X_CONST, name: 'Sombra texto X' }, // 16
  { id: TEXT_SHADOW_Y_CONST, name: 'Sombra texto Y' }, // 17
  { id: TEXT_SHADOW_BLUR_CONST, name: 'Sombra texto Blur' }, // 18
  { id: TEXT_SHADOW_COLOR_CONST, name: 'Sombra texto Color' }, // 19
  { id: FONT_STYLE_CONST, name: 'Estilo texto' }, // 20
];

export const getNameStyles = (id) =>
  stylesComponentArray.find((el) => el.id === id).name;

export const getIdTextComponent = (id) => {
  switch (id) {
    case TITLE_STYLES_CONST:
      return TITLE_TEXT_CONST;
    case SUBTITLE_STYLES_CONST:
      return SUBTITLE_TEXT_CONST;
    case TITLE_BACK_STYLES_CONST:
      return TITLE_BACK_TEXT_CONST;
    case SUBTITLE_BACK_STYLES_CONST:
      return SUBTITLE_BACK_TEXT_CONST;
    case FONDO_STYLES_CONST:
      return FONDO_CONST;
    case FONDO_BACK_STYLES_CONST:
      return FONDO_BACK_CONST;
    case TITLE_SECCION_STYLES_CONST:
      return TITLE_SECCION_TEXT_CONST;
    case TITLE_AGE_STYLES_CONST:
      return TITLE_AGE_TEXT_CONST;
    case TITLE_NIVEL_STYLES_CONST:
      return TITLE_NIVEL_TEXT_CONST;
    case LOGO_LEFT_STYLES_CONST:
      return LOGO_LEFT_CONST;
    case LOGO_RIGHT_STYLES_CONST:
      return LOGO_RIGHT_CONST;
    case LOGO_LEFT_BACK_STYLES_CONST:
      return LOGO_LEFT_BACK_CONST;
    case LOGO_RIGHT_BACK_STYLES_CONST:
      return LOGO_RIGHT_BACK_CONST;
    case FIRMA_STYLES_CONST:
      return FIRMA_CONST;
    case TITLE_FIRMA_STYLES_CONST:
      return TITLE_FIRMA_TEXT_CONST;
    case PARAMETRO1_STYLES:
      return PARAMETRO1;
    case PARAMETRO2_STYLES:
      return PARAMETRO2;

    default:
      return '';
  }
};
